/* eslint-disable arrow-body-style */
import { ReactNode } from 'react';
import { ReactComponent as ChevronDown } from '../../assets/chevron-down.svg';
import {
  CollapsableContainerTitle,
  CollapsableContainerWrapper,
  CollapsableContent,
  CollapsableContentInner,
} from './styles';

interface Props {
  title: ReactNode;
  children: ReactNode;
  isOpen?: boolean;
  onExpandClick: (isOpen: boolean) => void;
}

const CollapsableContainer = ({
  title,
  isOpen = false,
  onExpandClick,
  children,
}: Props) => {
  return (
    <CollapsableContainerWrapper $isOpen={isOpen}>
      <CollapsableContainerTitle
        type='button'
        onClick={() => onExpandClick(isOpen)}
        $isOpen={isOpen}>
        {title}
        <ChevronDown />
      </CollapsableContainerTitle>
      <CollapsableContent $isOpen={isOpen}>
        <CollapsableContentInner>{children}</CollapsableContentInner>
      </CollapsableContent>
    </CollapsableContainerWrapper>
  );
};

export default CollapsableContainer;
